import React from "react";
import { GridApiPro, gridColumnVisibilityModelSelector } from "@mui/x-data-grid-pro";
import { ExportColumnLayout } from "../../utils/tableColumnLayout";

/**
 * The grid's current column order (hidden columns included) and visibility — exactly
 * what the table shows, filter-driven columns included. Null while the grid isn't mounted.
 */
export const readGridColumnLayout = (
    apiRef?: React.MutableRefObject<GridApiPro>
): ExportColumnLayout | null => {
    if (!apiRef?.current?.getAllColumns || !apiRef.current.state) return null;
    return {
        order: apiRef.current.getAllColumns().map((col) => col.field),
        visibility: gridColumnVisibilityModelSelector(apiRef),
    };
};
